import { Component, OnInit, Renderer2 } from '@angular/core';
// Translation services
import { TranslateService } from '@ngx-translate/core';
import * as myGlobalFunc from '../../global.function';
import { AuthService } from '../../auth/auth.service';
import { Router } from '@angular/router';
import { FooterService } from './footer.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
  public isSystemAdmin: any = 0;
  public displayTC: any = false; //  flag for terms and conditions
  public displayPP: any = false; //  flag for priavcy policy
  public displaySA: any = false; //  flag for Service agreement
  public display: any = false;
  public pageContent: any = [];

  public globalSettings: any = false;
  public showSystemMessage: any = false;
  public systemMessage: string;
  public copyrightYear: any;

  constructor(
    // Translator service Injection
    private translate: TranslateService,
    private renderer: Renderer2,
    private authService: AuthService,
    private footerServuce: FooterService,
    private router: Router
  ) {
    this.translate.setDefaultLang('en');
    const url = window.location.href;
    this.copyrightYear = new Date().getFullYear();
    if (this.authService.isLoggedIn()) {
      this.footerServuce.setHeader().subscribe(res => {
        if (res.status === 1) {
          this.isSystemAdmin = res.data.isSystemAdmin;
        }
      });
    }
  }
  // function: show dialog on link click
  // params: type
  showDialog(type) {
    this.displayTC = false;
    this.displayPP = false;
    this.displaySA = false;
    switch (type) {
      case 'TC':
        this.displayTC = true; // code...
        break;
      case 'PP':
        this.displayPP = true;
        // code...
        break;
      case 'SA':
        this.displaySA = true;
        // code...
        break;

      default:
        // code...
        this.displayTC = false;
        this.displayPP = false;
        this.displaySA = false;
        break;
    }
  }

  ngOnInit() {
    this.updateSystemSettings();
  }

  closeDialog(type) {
    switch (type) {
      case 'TC':
        this.displayTC = false;
        break;
      case 'PP':
        this.displayPP = false;
        break;
      case 'SA':
        this.displaySA = false;
        break;
    }
  }

  // function to check for system settings
  updateSystemSettings() {
    const formData = {};
    this.authService.settingsAPI(1, formData).subscribe(data => {
      if (data.status === 1) {
        let counter = 0;
        data.systemSettings.map(item => {
          switch (item.settings_key) {
            case 'maintenance_mode':
              this.checkAndRedirectPage(item.settings_value); // check for maintenance_mode and redirect
              break;
            case 'system_message':
              this.checkAndDisplayMessage(item.settings_value); // check for maintenance_mode and redirect
              break;
            default:
              this.storeValues(
                item.settings_key,
                item.settings_value,
                item.dateUpdated
              );
              break;
          }
          counter++;
        });
        if (data.systemSettings.length === counter) {
          this.globalSettings = true;

          const pagesArray = [
            'terms_conditions_page',
            'service_agreement_page',
            'privacy_policy_page'
          ];
          pagesArray.forEach(page => {
            if (window.localStorage.getItem(page)) {
              this.pageContent[page] = window.localStorage.getItem(page);
              this.pageContent[`${page}_updated`] = myGlobalFunc.convertDate(
                new Date(
                  window.localStorage.getItem(`${page}_updated`) + ' UTC'
                ),
                false
              );
            } else {
              this.pageContent[page] = '';
              this.pageContent[`${page}_updated`] = '';
            }
          });
        }
      }
    });
  }

  // redirect in case of maintenance mode
  checkAndRedirectPage(val) {
    if (Number(val) === 1) {
      // if value is yes, then redirect
      this.router.navigate(['/maintenance']);
    }
  }

  // show notification bar in case of system message
  checkAndDisplayMessage(message) {
    if (message && message.length > 0) {
      // if value is not empty, then show message
      this.systemMessage = message;
      this.showSystemMessage = true;
      this.renderer.addClass(document.body, 'display-system-message');
    } else {
      this.renderer.removeClass(document.body, 'display-system-message');
    }
  }

  // settings values - local storage
  storeValues(sKey, sValue, sUpdated) {
    window.localStorage.setItem(sKey, sValue);
    window.localStorage.setItem(`${sKey}_updated`, sUpdated);
  }
}
